export type ButtonSize = 'sm' | 'md' | 'lg' | 'hero'
export type ButtonTone = 'coral' | 'inverse'

const BASE =
  'group inline-flex min-w-0 max-w-full items-center justify-center gap-2.5 rounded-full text-center font-sans font-extrabold transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4'

const TONES: Record<ButtonTone, string> = {
  coral:
    'bg-coral-deep text-white shadow-[0_12px_24px_-16px_rgba(179,51,90,0.8)] hover:bg-coral-press focus-visible:ring-coral/40',
  inverse: 'bg-paper text-coral-ink hover:bg-blush focus-visible:ring-white/60',
}

/**
 * Long labels may wrap to two centered lines on narrow phones; height grows
 * with the text instead of overflowing. Only the short `sm` label stays on one line.
 */
const SIZES: Record<ButtonSize, string> = {
  sm: 'min-h-[48px] whitespace-nowrap px-5 text-[0.95rem]',
  md: 'h-auto min-h-[52px] px-6 py-3 text-[1rem] leading-tight text-balance',
  lg: 'h-auto min-h-[56px] w-full px-5 py-3 text-[1rem] leading-tight text-balance sm:w-auto sm:px-8 sm:text-[1.05rem]',
  hero: 'h-auto min-h-[52px] w-full px-5 py-3 text-[1rem] leading-tight text-balance sm:w-auto sm:px-8 sm:text-[1.02rem]',
}

/** Primary coral button classes, shared by every purchase CTA. */
export function primaryButtonClass(size: ButtonSize = 'md', tone: ButtonTone = 'coral'): string {
  return `${BASE} ${TONES[tone]} ${SIZES[size]}`
}

/** Quiet outlined link used for secondary, in-page actions. */
export const secondaryLinkClass =
  'group inline-flex h-auto min-h-[52px] w-full min-w-0 max-w-full items-center justify-center gap-2 rounded-full px-6 py-3 text-center text-[1rem] font-bold leading-tight text-graphite ring-1 ring-inset ring-graphite/20 transition-[box-shadow,color,background-color] duration-150 ease-out hover:bg-paper hover:ring-graphite/40 focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40 sm:w-auto'
